import React from 'react'
import { Header } from 'semantic-ui-react'
import { Loader } from '@carsys/ui'

interface IChartHeaderProps {
  title: string
  loading?: boolean
}

export const ChartHeader: React.FC<IChartHeaderProps> = props => {
  return (
    <div className='chart-header-container'>
      <Header as='h2' textAlign='left'>
        {props.title}
      </Header>
      {props.loading && <Loader loading />}
    </div>
  )
}
